import { createAction, props } from "@ngrx/store";
import { DataSourceSummary } from "./union.model";

export const loadDataSources = createAction(
  "[DataSource/API] Load DataSources",
);

export const loadDataSourcesSuccess = createAction(
  "[DataSource/API] Load DataSources Success",
  props<{ dataSources: DataSourceSummary[] }>(),
);

export const loadDataSourcesFailure = createAction(
  "[DataSource/API] Load DataSources Failure",
  props<{ error: any }>(),
);

export const addDataSourceSuccess = createAction(
  "[DataSource/API] Add DataSource Success",
  props<{ dataSource: DataSourceSummary }>(),
);

export const updateDataSource = createAction(
  "[DataSource/API] Update DataSource",
  props<{ dataSource: DataSourceSummary }>(),
);

export const updateDataSourceSuccess = createAction(
  "[DataSource/API] Update DataSource Success",
  props<{ dataSource: DataSourceSummary }>(),
);

export const updateDataSourceFailure = createAction(
  "[DataSource/API] Update DataSource Failure",
  props<{ error: any }>(),
);

export const deleteDataSource = createAction(
  "[DataSource/API] Delete DataSource",
  props<{ dataSource: DataSourceSummary }>(),
);

export const deleteDataSourceSuccess = createAction(
  "[DataSource/API] Delete DataSource Success",
  props<{ id: string }>(),
);

export const deleteDataSourceFailure = createAction(
  "[DataSource/API] Delete DataSource Failure",
  props<{ error: any }>(),
);
